import { render, staticRenderFns } from "./PbTabPanal.vue?vue&type=template&id=04b3f9d4&"
import script from "./PbTabPanal.vue?vue&type=script&lang=js&"
export * from "./PbTabPanal.vue?vue&type=script&lang=js&"
import style0 from "./PbTabPanal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports